import { SpecialZoomLevel, Viewer, Worker } from '@react-pdf-viewer/core';

import React, { useState } from 'react';
import '@react-pdf-viewer/core/lib/styles/index.css';

function CustomPDFDisplay(
    {
        pdfFile,
        displayUser = null,
    } ) {
    const [ _viewerState, setViewerState ] = useState( null );

    return (
        <div className='text-center text-white pt-5'>
            { pdfFile ? (
                <div style={ { height: '750px' } }>
                    <h2 className="text center pb-4">CV d'origine : </h2>
                    <p className='h4'>{ displayUser?.prenom } { displayUser?.nom }</p>
                    <Worker workerUrl={ `${ process.env.PUBLIC_URL }/pdf.worker.min.js` }>
                        <Viewer
                            fileUrl={ pdfFile }
                            onStateChange={ setViewerState }
                            initialZoom={ SpecialZoomLevel.PageFit }
                        />
                    </Worker>
                </div>
            ) : (
                <div className="text-center text-white">
                    <p>Aucun fichier PDF sélectionné</p>
                </div>
            ) }
        </div>
    );
}

export default CustomPDFDisplay;
